import {
    InteractionEntity,
    InteractionEntityType,
    NoteEntity,
    NoteEntityType,
} from '../../../coaching-base/config';
import { PayloadAction } from '../../../store.model';
import { View } from '../enum/view.enum';
import { createFocusTags } from '../function/create-behaviour-tags.function';
import { determineAllowedActions } from '../function/determine-allowed-actions.function';
import { ActionType } from '../transcript-dialog.action';
import {
    defaultState,
    TranscriptDialogState,
} from '../transcript-dialog.state';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    _state: TranscriptDialogState,
    _action: PayloadAction<ActionType.COACHING_DETAIL__TD__RELOAD, Reload>,
): TranscriptDialogState {
    const next = defaultState();
    next.pending.reload = true;
    return next;
}

export function reloadResultReducer(
    state: TranscriptDialogState,
    action: PayloadAction<
        ActionType.COACHING_DETAIL__TD__RELOAD_RESULT,
        ReloadResult
    >,
): TranscriptDialogState {
    try {
        action.payload.transcript?.quotes?.sort(
            (a, b) =>
                (a.index ?? Number.MIN_VALUE) - (b.index ?? Number.MIN_VALUE),
        );

        const nextHasSummary =
            action.payload.transcript?.summary != null &&
            action.payload.transcript?.summary?.trim().length !== 0;
        const nextHasResult = action.payload.transcript?.caResult != null;
        const nextHasCoachAssist = nextHasSummary || nextHasResult;
        const nextHasDesc =
            action.payload.transcript?.description != null &&
            action.payload.transcript?.description?.trim()?.length !== 0;
        const nextView = nextHasCoachAssist ? View.LANDING : View.NOTES;

        const nextAllowedActions = determineAllowedActions();

        const nextFilteredQuotes =
            action.payload.transcript?.quotes != null
                ? [...action.payload.transcript.quotes]
                : [];

        const nextSliderOptions = {
            floorNum: 0,
            ceilNum:
                action.payload.transcript?.quotes == null ||
                action.payload.transcript.quotes.length === 0
                    ? 1
                    : (action.payload.transcript.quotes
                          .at(-1)
                          ?.endTime?.getTime() -
                          action.payload.transcript.quotes[0]?.endTime?.getTime()) /
                      1000,
        };

        const nextNoteEntity = (
            action.payload.observationConfig?.childEntities?.find(
                (a) => a.entityType === InteractionEntityType,
            ) as InteractionEntity
        )?.childEntities.find(
            (e) => e.entityType === NoteEntityType,
        ) as NoteEntity;

        const nextPrimaryFocusTag = createFocusTags(
            action.payload.transcript?.focuses?.filter(
                (e) => e.isPrimary === true,
            ),
            action.payload.behaviours,
            action.payload.subBehaviours,
        )?.[0];

        const nextBehaviourTags = createFocusTags(
            action.payload.transcript?.focuses?.filter(
                (e) => e.isPrimary !== true,
            ),
            action.payload.behaviours,
            action.payload.subBehaviours,
        );

        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
            summaryEnabled: nextHasSummary,
            evaluationEnabled: nextHasResult,
            hasCoachAssist: nextHasCoachAssist,
            hasDesc: nextHasDesc,
            view: nextView,
            allowedActions: nextAllowedActions,
            transcript: action.payload.transcript,
            filteredQuotes: nextFilteredQuotes,
            sliderOptions: nextSliderOptions,
            behaviours: action.payload.behaviours,
            subBehaviours: action.payload.subBehaviours,
            noteEntity: nextNoteEntity,
            primaryFocusTag: nextPrimaryFocusTag,
            behaviourTags: nextBehaviourTags,
            cmtNotesFocus: nextPrimaryFocusTag,
        };
    } catch (err) {
        console.log(err);
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
        };
    }
}
